import { Link } from "react-router-dom";
import ArticleCard from "@/components/feature/ArticleCard";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { articles } from "@/mocks/articles";
import { formatHeat, getCategoryName } from "@/utils/content";

export default function FeaturedSection() {
  const featured = articles.filter((item) => item.featured);
  const lead = featured[0] ?? articles[0];
  const sideList = articles.filter((item) => item.slug !== lead.slug).slice(0, 4);

  return (
    <section id="featured" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="本期精选"
            title="假期里最值得完整读一遍的几篇"
            desc="从票房、营销到出行体验，挑出信息密度最高的几篇长文，读完基本能覆盖假期的主要内容脉络。"
          />
        </Reveal>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-12">
          <Reveal className="lg:col-span-7" delay={60}>
            <Link
              to={`/topics/${lead.slug}`}
              className="group flex h-full cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
            >
              <div className="h-56 w-full overflow-hidden bg-background-200 md:h-72">
                <img
                  src={lead.cover}
                  alt={lead.title}
                  title={`${lead.title} - 五一假期事件盘点`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
                />
              </div>
              <div className="flex flex-1 flex-col gap-3 p-5 md:p-7">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="rounded-full bg-primary-100 px-2.5 py-1 text-xs font-medium text-primary-700">
                    {getCategoryName(lead.category)}
                  </span>
                  <span className="rounded-full bg-secondary-100 px-2.5 py-1 text-xs font-medium text-secondary-800">
                    深度盘点
                  </span>
                </div>
                <h3 className="font-heading text-xl font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-2xl">
                  {lead.title}
                </h3>
                <p className="text-sm leading-relaxed text-foreground-600">{lead.excerpt}</p>
                <div className="mt-auto flex flex-wrap items-center gap-4 pt-2 text-xs text-foreground-400">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-user-line" />
                    {lead.author}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-calendar-line" />
                    {lead.dateText}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-fire-line" />
                    {formatHeat(lead.hot)} 热度
                  </span>
                </div>
              </div>
            </Link>
          </Reveal>

          <Reveal className="lg:col-span-5" delay={120}>
            <div className="flex h-full flex-col rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
              <h3 className="font-heading text-base font-bold text-foreground-950">编辑推荐速览</h3>
              <p className="mt-1.5 text-xs text-foreground-500">按阅读完成度排序，适合通勤路上快速浏览。</p>
              <div className="mt-2 flex-1">
                {sideList.map((item) => (
                  <ArticleCard key={item.id} article={item} variant="compact" />
                ))}
              </div>
              <Link
                to="/topics"
                className="mt-4 inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
              >
                查看全部文章
                <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}